import { SegmentedControl } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import type { NotificationLanguage } from '@xver/apis/v1/notification-preferences/model';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';

interface LanguageSectionProps {
    language: NotificationLanguage;
    onChange: (next: NotificationLanguage) => void;
    /** Changes are ignored while true; the control stays enabled so it keeps focus. */
    isSaving?: boolean;
}

export default function LanguageSection({ language, onChange, isSaving }: LanguageSectionProps) {
    const { t, i18n } = useTranslation('settings');

    const handleChange = (next: string) => {
        if (isSaving) return;
        const lang = (next === 'en' ? 'en' : 'th') as NotificationLanguage;
        i18n.changeLanguage(lang);
        onChange(lang);
    };

    return (
        <DialogBox
            label={t('language.title')}
            description={t('language.description')}
            classNames="p-4"
        >
            <SegmentedControl
                aria-label={t('language.title')}
                value={language}
                onChange={handleChange}
                data={[
                    { label: t('language.th'), value: 'th' },
                    { label: t('language.en'), value: 'en' },
                ]}
            />
        </DialogBox>
    );
}
